(()=>{
  const reduce=matchMedia('(prefers-reduced-motion: reduce)');
  const ios=/iPad|iPhone|iPod/.test(navigator.userAgent)||(/Macintosh/.test(navigator.userAgent)&&navigator.maxTouchPoints>1);
  const buttons='[data-add],[data-sticky-add],[data-shr-sticky-add],[data-shr-play], .bw-button,[data-cart-key]:not([data-cart-remove])';
  const choices='.shr-offer input[type=radio],.bw-offer input[type=radio],.bw-pack-options input[type=radio]';
  let last=0;
  function feedback(element,intense=false){
    if(!element||element.disabled||Date.now()-last<90)return;
    last=Date.now();
    if(!ios&&typeof navigator.vibrate==='function'){try{navigator.vibrate(intense?[22,35,12]:18)}catch{}}
    if(reduce.matches)return;
    const box=element.getBoundingClientRect();
    if(box.bottom<0||box.top>innerHeight)return;
    if(element.matches('[data-add],[data-sticky-add],[data-shr-sticky-add]'))return;
    window.bwTapBurst?.(element);

  }
  window.bwFeedback=feedback;
  document.addEventListener('click',e=>{if(e.target.matches('[data-bw-native-haptic]'))return;const b=e.target.closest(buttons);if(b)feedback(b,b.matches('[data-add],[data-sticky-add],[data-shr-sticky-add]'))});
  document.addEventListener('change',e=>{if(e.target.matches(choices+', [data-pair-select]'))feedback(e.target.closest('label')||e.target)});
  if(!ios&&!document.documentElement.hasAttribute('data-bw-haptic-preview'))return;
  const bridges=new WeakMap();let index=0;
  function attach(control){
    if(bridges.has(control))return;
    const radio=control.matches('input[type=radio]');let shell;
    if(radio){
      shell=control.closest('label');if(!shell)return;
      if(!control.id)control.id='bw-haptic-choice-'+(++index);
      shell.htmlFor=control.id;shell.classList.add('bw-haptic-choice');
    }else{
      shell=document.createElement('span');shell.className='bw-haptic-shell';
      if(control.matches('[data-add]'))shell.classList.add('bw-haptic-add');
      control.before(shell);shell.append(control);
    }
    const input=document.createElement('input');input.type='checkbox';input.setAttribute('switch','');input.setAttribute('data-bw-native-haptic','');input.setAttribute('aria-hidden','true');input.tabIndex=-1;input.disabled=control.disabled||false;
    bridges.set(control,input);
    // Keep the native switch (and its iOS tap rendering) inside an invisible clipped layer.
    const hitbox=document.createElement('i');hitbox.className='bw-haptic-hitbox';hitbox.setAttribute('aria-hidden','true');
    hitbox.append(input);shell.append(hitbox);
    let startX=0,startY=0,dragged=false;
    input.addEventListener('touchstart',e=>{startX=e.touches[0].clientX;startY=e.touches[0].clientY;dragged=false},{passive:true});
    input.addEventListener('touchmove',e=>{if(Math.abs(e.touches[0].clientX-startX)>12||Math.abs(e.touches[0].clientY-startY)>12)dragged=true},{passive:true});
    input.addEventListener('touchcancel',()=>{dragged=true},{passive:true});
    input.addEventListener('click',e=>{e.stopPropagation()});
    input.addEventListener('change',e=>{
      e.stopPropagation();
      if(dragged||control.disabled){dragged=false;return}
      if(radio){
        if(!control.checked){control.checked=true;control.dispatchEvent(new Event('change',{bubbles:true}))}else feedback(shell);
      }else control.click();
    });
  }
  function scan(root){
    if(root.nodeType!==1&&root.nodeType!==9)return;
    if(root.matches?.(buttons+','+choices))attach(root);
    root.querySelectorAll(buttons+','+choices).forEach(attach);
  }
  scan(document);
  new MutationObserver(records=>{
    records.forEach(r=>{
      if(r.type==='attributes'){const input=bridges.get(r.target);if(input)input.disabled=r.target.disabled||false}
      else r.addedNodes.forEach(scan);
    });
  }).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled']});
})();

